import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserSessionStorage } from '../_interfaces/others.interface';

@Injectable({
    providedIn: 'root',
})

export class StorageService {

    currentUserSessionStorage: UserSessionStorage;
    currentUserSessionStorageSubject$ = new BehaviorSubject<UserSessionStorage>(this.getDefaultUserSessionStorage());
    currentUserSessionStorage$: Observable<UserSessionStorage> = this.currentUserSessionStorageSubject$.asObservable();
    constructor() {
        const userSessionStorage = sessionStorage.getItem('userSessionStorage');
        if (userSessionStorage) {
            this.currentUserSessionStorage = JSON.parse(userSessionStorage);
            this.updateSubject();
        } else {
            this.currentUserSessionStorage = this.getDefaultUserSessionStorage();
            this.updateSubject();
        }
    }

    updateSubject() {
        this.currentUserSessionStorageSubject$.next(this.currentUserSessionStorage);
    }

    public setUser(data: any): void {
        localStorage.setItem('user', JSON.stringify(data));
    }

    public getUser(): any {
        return JSON.parse(localStorage.getItem('user') || '{}')!;
    }

    public clearLocalStore(): void {
        localStorage.clear();
        sessionStorage.clear();
    }

    resetUserSessionStorage(prefix = '', notifySubject = true) {
        // If a vlaid prefix is provided, only reset the keys that start with that prefix (e.g. 'widget')
        const defaultSessionStorage = this.getDefaultUserSessionStorage();
        const keys = Object.keys(defaultSessionStorage) as Array<keyof UserSessionStorage>;
        if (prefix) {
            keys.forEach(key => {
                if (key.startsWith(prefix)) {
                    this.currentUserSessionStorage[key] = defaultSessionStorage[key];
                }
            });
        } else {
            this.currentUserSessionStorage = defaultSessionStorage;
        }
        this.saveToSessionStorage();
        if (notifySubject) {
            this.updateSubject();
        }
    }

    getDefaultUserSessionStorage() {
        return {
            blogColumns: []
        };
    }

    getUserSessionStorageItem<K extends keyof UserSessionStorage>(key: K): UserSessionStorage[K] {
        return this.currentUserSessionStorage[key];
    }

    setUserSessionStorageItem<K extends keyof UserSessionStorage>(key: K, value: UserSessionStorage[K], notifySubject = true) {
        this.currentUserSessionStorage[key] = value;
        this.saveToSessionStorage();
        if (notifySubject) {
            this.updateSubject();
        }
    }

    getUserSessionStorage() {
        return this.currentUserSessionStorage;
    }

    setUserSessionStorage(item: UserSessionStorage, notifySubject = true) {
        this.currentUserSessionStorage = item;
        this.saveToSessionStorage();
        if (notifySubject) {
            this.updateSubject();
        }
    }

    saveToSessionStorage() {
        sessionStorage.setItem('userSessionStorage', JSON.stringify(this.currentUserSessionStorage));
    }
}
